import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmationPopupComponent } from './confirmation-popup.component';
import { IonicModule } from '@ionic/angular';



@NgModule({
  declarations: [ConfirmationPopupComponent],
  imports: [
    CommonModule,
    IonicModule
  ]
})
export class ConfirmationPopupComponentModule { }
